var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopReturn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "10 9 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-643.000000, -645.000000) translate(286.000000, 304.000000) translate(0.000000, 233.000000) translate(362.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    className: "icon-stroke",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5V4.167C10.5 1.865 8.71 0 6.5 0s-4 1.865-4 4.167V7.5",
    transform: "translate(12.250000, 12.250000) rotate(90.000000) translate(-12.250000, -12.250000) translate(7.000000, 8.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5L2.5 8.5 0 6.5",
    transform: "translate(12.250000, 12.250000) rotate(90.000000) translate(-12.250000, -12.250000) translate(7.000000, 8.000000)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopReturn);
export default __webpack_public_path__ + "static/media/stop-return.33eacd6983d090bd997e5f363985685f.svg";
export { ForwardRef as ReactComponent };